import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import { useHistory } from 'react-router-dom';
import posts from './posts';
import usePageMeta from '../../hooks/usePageMeta';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(12),
    marginBottom: theme.spacing(8),
  },
  hero: {
    marginBottom: theme.spacing(6),
    textAlign: 'left',
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    flexGrow: 1,
  },
  date: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  summary: {
    marginTop: theme.spacing(1),
  },
}));

export default function Blog() {
  const classes = useStyles();
  const history = useHistory();
  usePageMeta('Blog', 'Research-backed articles on habit recovery, focus, and digital wellbeing from The Warrior Tribe.');

  return (
    <Container maxWidth="md" className={classes.root}>
      <div className={classes.hero}>
        <Link href="/" color="primary" style={{ display: 'inline-block', marginBottom: 16 }}>
          ← Back to Home
        </Link>
        <Typography variant="h3" gutterBottom>
          The Warrior Tribe Blog
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Research, insights, and honest writing on breaking free from compulsive explicit content use — and what life looks like on the other side.
        </Typography>
      </div>

      <Grid container spacing={4}>
        {posts.map((post) => (
          <Grid item xs={12} sm={6} key={post.slug}>
            <Card className={classes.card}>
              <CardActionArea onClick={() => history.push(`/blog/${post.slug}`)} style={{ height: '100%' }}>
                <CardContent className={classes.cardContent}>
                  <Typography variant="caption" className={classes.date}>
                    {post.date}
                  </Typography>
                  <Typography variant="h6" gutterBottom>
                    {post.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" className={classes.summary}>
                    {post.summary}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
